import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Condiciones",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "earlyCharge",
        displayName: "%cobro",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
      },
      {
        fieldName: "policies",
        displayName: "Política de Cancelación",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Mínimo",
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "earlyCharge",
        displayName: "% cobro anticipado",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Cobro mínimo",
      },
      {
        fieldName: "policies",
        displayName: "Políticas de cancelación",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Cancelaciones / Pago por adelantado",
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Hora check-in",
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Hora check-out",
      },
      {
        fieldName: "htmlChildren",
        displayName: "Niños y camas supletorias",
      },
      {
        fieldName: "htmlPets",
        displayName: "Mascotas",
      },
      {
        fieldName: "htmlGroups",
        displayName: "Grupos",
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "Más información",
      },
    ],
  },
};
